import { TCurrency } from "@/api/v1_0";

export namespace Currency {
  export const currencies: Array<TCurrency> = [
    TCurrency.EUR,
    TCurrency.RUB,
    TCurrency.USD,
  ];

  export const symbol = (currency: TCurrency): string =>
    ({
      [TCurrency.EUR]: "€",
      [TCurrency.RUB]: "₽",
      [TCurrency.USD]: "$",
    })[currency];
}
